import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Badge, Box } from '@mui/material';
import IconButton from 'components/@extended/IconButton';
import { Like1 } from 'iconsax-react';
import { ThemeMode } from 'types/config';
import OrderRequestDrawerRecommendation from './OrderRequestDrawerRecommendation';

interface Props {
  recommendationRequestCount: number;
  setRecommendationRequestCount: (val: number) => void;
}

const RecommendationOrderRequest = ({ setRecommendationRequestCount, recommendationRequestCount }: Props) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'secondary.200' : 'secondary.200';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'secondary.100';

  return (
    <>
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <Badge
          badgeContent={recommendationRequestCount}
          color="error"
          overlap="circular"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <IconButton
            color="secondary"
            variant="light"
            onClick={handleToggle}
            aria-label="settings toggler"
            size="large"
            sx={{ color: 'secondary.main', bgcolor: open ? iconBackColorOpen : iconBackColor, p: 1 }}
          >
            <Like1 variant="Bulk" />
          </IconButton>
        </Badge>
      </Box>
      {open && (
        <OrderRequestDrawerRecommendation open={open} setOpen={setOpen} setRecommendationRequestCount={setRecommendationRequestCount} />
      )}
    </>
  );
};

export default RecommendationOrderRequest;
